<template>
  <div class="el-emp-footer">
    <div class="service ">
      <div class="wrapper">
        <ul class="service-list">
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-sharing-o" />
              <p class="service-txt">{{ serviceItemData[0] }}</p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-high-quality-service" />
              <p class="service-txt">{{ serviceItemData[1] }}</p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-star-o" />
              <p class="service-txt">{{ serviceItemData[2] }}</p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-rmb-o" />
              <p class="service-txt">{{ serviceItemData[3] }}</p>
            </div>
          </li>
          <li class="service-item">
            <div class="service-unit">
              <i class="icon-ccui-promote-o" />
              <p class="service-txt">{{ serviceItemData[4] }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="divider"></div>
    <div class="help">
      <div class="wrapper">
        <div class="help-list">
          <div class="help-nav" v-for="(item, index) in helpData" :key="index">
            <div>
              <h5 class="help-nav-tit">{{ item.tit }}</h5>
              <ul class="help-nav-con">
                <li v-for="(con, i) in item.list" :key="i">
                  <a v-if="con.url" :href="con.url" target="_blank">
                    <p>{{ con.label }}</p>
                  </a>
                  <p v-else style="cursor: default;">{{ con.label }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="help-nav">
            <div class="help-nav-con qrcode-wrapper">
              <div class="qrcode">
                <img :src="qrCode" alt="" />
              </div>
              <div class="tit">{{ Wx }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="isShowCopyright">
      <div class="divider second"></div>
      <div class="copy-right-wrapper">
        <div class="copy-right">
          <div>{{ copyRighta }}</div>
          <div class="h-divider"></div>
          <p>
            {{ divider
            }}<a
              href="https://beian.miit.gov.cn/"
              style="color: inherit;"
              target="_blank"
              >{{ copyRightb }}</a
            >
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ElEmpFooter",
  props: {
    qrCode: {
      type: String,
      default: ""
    },
    Wx: {
      type: String,
      default: "官方微信"
    },
    copyRighta: {
      type: String,
      default: "Copyright©2022中交电商All rights reserved."
    },
    copyRightb: {
      type: String,
      default: "闽ICP备 2022005227号-2 中交电商"
    },
    divider: {
      type: String,
      default: "最终解释权："
    },
    isShowCopyright: {
      type: Boolean,
      default: true
    },
    helpData: {
      type: Array,
      default() {
        return [];
      }
    },
    serviceItemData: {
      type: Array,
      default() {
        return ["资源共享", "优质服务", "合法合规", "降本增效", "管理提升"];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.help-list {
  display: flex;
  justify-content: space-between;
}
.el-emp-footer .help .wrapper .help-list .help-nav .help-nav-con li p {
  display: inline-block;
}
</style>
